import { Link } from 'react-router-dom';
import { AdSlot } from '../components/UI';

const CALCULATORS = [
  {
    path: '/rent',
    name: 'Can I Afford This Apartment?',
    desc: 'Find your rent sweet spot before you sign anything.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/>
      </svg>
    ),
  },
  {
    path: '/credit-card',
    name: 'Credit Card Payoff',
    desc: 'See exactly how long and how much that debt will actually cost you.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="15" x2="10" y2="15"/>
      </svg>
    ),
  },
  {
    path: '/mortgage',
    name: 'How Much House Can I Afford?',
    desc: "Get a realistic number, not a bank's optimistic approval.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1v-9.5z"/><rect x="8" y="13" width="3" height="8"/><rect x="13" y="13" width="3" height="5"/>
      </svg>
    ),
  },
  {
    path: '/retirement',
    name: 'Am I Saving Enough for Retirement?',
    desc: "Find out if you're on track before it's too late.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
      </svg>
    ),
  },
  {
    path: '/debt-invest',
    name: 'Pay Off Debt or Invest?',
    desc: 'The eternal question, finally answered for your situation.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="3" x2="12" y2="21"/><path d="M17 6H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
      </svg>
    ),
  },
  {
    path: '/raise',
    name: "What's My Raise Actually Worth?",
    desc: 'See your real take-home after taxes.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/><path d="M9 9h6M9 12h6M9 15h4"/><path d="M15 9v6"/>
      </svg>
    ),
  },
  {
    path: '/millionaire',
    name: "How Long Until I'm a Millionaire?",
    desc: 'Compound interest is wild. See it for yourself.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
      </svg>
    ),
  },
  {
    path: '/savings-growth',
    name: 'Savings Growth Calculator',
    desc: 'See how much your savings have actually grown over any period of time.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
  },
];

export default function Home() {
  return (
    <div>
      <div className="hero">
        <div className="hero-inner">
          <div className="hero-badge fade-up">Free Financial Tools</div>
          <h1 className="fade-up fade-up-d1">Financial <em>clarity,</em><br />finally.</h1>
          <p className="fade-up fade-up-d2">Free calculators that actually explain what the numbers mean — in plain English. No jargon, no sign-up, no BS.</p>
          <div className="trust-pills fade-up fade-up-d3">
            <div className="trust-pill">No sign-up required</div>
            <div className="trust-pill">100% free forever</div>
            <div className="trust-pill">Your data never leaves your browser</div>
          </div>
        </div>
      </div>

      <div className="section">
        <AdSlot />
        <div className="section-title">8 Calculators for Real Decisions</div>
        <div className="section-sub">Pick the question that's keeping you up at night.</div>
        <div className="calc-grid">
          {CALCULATORS.map(c => (
            <Link key={c.path} to={c.path} className="calc-card">
              <div className="calc-icon">{c.icon}</div>
              <h3>{c.name}</h3>
              <p>{c.desc}</p>
              <div className="calc-arrow">Calculate <span>→</span></div>
            </Link>
          ))}
        </div>
        <AdSlot />
      </div>

      <footer>
        <div className="footer-inner">
          <div className="footer-top">
            <div>
              <div className="footer-logo">Finance<span>Calculator</span>.cc</div>
              <div className="footer-tagline">Financial clarity for real people.</div>
            </div>
            <div className="footer-links">
              {CALCULATORS.map(c => <Link key={c.path} to={c.path}>{c.name}</Link>)}
              <Link to="/currency">Currency Converter</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-disclaimer">FinanceCalculator.cc calculators are for educational purposes only and do not constitute financial advice. All calculations happen in your browser — we never store your data.</div>
            <div className="footer-copy">© 2026 FinanceCalculator.cc — <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy Policy</Link> · Made with ☕</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
